const META_TESTING_ORG_ID = "1781185242985";

export function shouldHideWahaUiForOrg(orgId?: string | null): boolean {
  return orgId === META_TESTING_ORG_ID;
}
